<mat-card
  class="notification-settings-card"
  id="notification-settings"
  aria-labelledby="notification-settings-title"
>
  <app-card-header-with-action
    title="Benachrichtigungseinstellungen"
    i18n-title="@@notificationSettingsTitle"
    headingId="notification-settings-title"
    [actionDisabled]="!data.settings()"
    (actionClicked)="edit()"
  />
  @if (data.loading()) {
    <div class="loading">
      <mat-spinner
        diameter="28"
        aria-label="Benachrichtigungseinstellungen werden geladen"
        i18n-aria-label="@@notificationSettingsLoading"
      />
    </div>
  } @else if (data.settings(); as settings) {
    <mat-list>
      @for (channel of channels; track channel.key) {
        <mat-list-item>
          <mat-icon matListItemIcon aria-hidden="true">{{
            channel.icon
          }}</mat-icon>
          <div matListItemTitle>{{ channel.label }}</div>
          <div matListItemLine>
            @if (settings[channel.key]) {
              <span i18n="@@notificationSettingsEnabled">Aktiviert</span>
            } @else {
              <span i18n="@@notificationSettingsDisabled">Deaktiviert</span>
            }
          </div>
        </mat-list-item>
      }
    </mat-list>
  } @else if (data.failed()) {
    <div class="load-error" role="alert">
      <span i18n="@@notificationSettingsLoadError"
        >Benachrichtigungseinstellungen konnten nicht geladen werden.</span
      ><button
        mat-button
        type="button"
        (click)="data.load(true)"
        i18n="@@notificationTryAgain"
      >
        Erneut versuchen
      </button>
    </div>
  }
</mat-card>
